import React from "react";
import { Form, Popover, Upload } from "antd";
import UploadUtils from "../../utilities/uploadUtils";
import SortDraggableList from "../SortDraggableList";
import { QuestionCircleOutlined } from "@ant-design/icons";

const FooterAcceptedPaymentSort = ({ data, setData, form }) => {
  const acceptedPaymentItems =
    data?.accepted_payments?.map((item, index) => ({
      id: index.toString(),
      ...item,
    })) || [];

  const renderPaymentContent = (field) => (
    <Form.Item
      label={
        <span>
          Payment Image{" "}
          <Popover placement="right" title="W * H" content="36 x 36">
            <QuestionCircleOutlined />
          </Popover>
        </span>
      }
      name={[field.name, "payment_image"]}
      {...UploadUtils.formItemProps}
      wrapperCol={{ span: 24 }}
    >
      <Upload {...UploadUtils.buttonPreviewProps}>
        <UploadUtils.CardContent />
      </Upload>
    </Form.Item>
  );

  return (
    <SortDraggableList
      items={acceptedPaymentItems}
      renderContent={renderPaymentContent}
      setData={setData}
      form={form}
      formField="accepted_payments"
      addContent={true}
      showRemoveOption={true}
      cardTitle="Payment Image"
    />
  );
};

export default FooterAcceptedPaymentSort;
